// Helper functions to create OpenAPI objects, and get Base URLs for Websockets.
// This module decides which URL to use for the API depending on the situation.

import * as api from "@nens/brostar/openapi-client";
import * as uploadApi from "@nens/brostar/uploadapi-client";

const HOST = window.location.host;

const ISLOCALHOST = window.location.hostname === "localhost";

const API_PROTOCOL = ISLOCALHOST ? "http" : "https";

const CONFIGURATION = new api.Configuration({
  basePath: `${API_PROTOCOL}://${HOST}`,
  credentials: "include", // Otherwise fetch doesn't send the auth cookie
});

export const getLoginLogoutUrl = (url: string) =>
  url + (ISLOCALHOST ? "?next=/api/localhost-redirect" : "");

export const getApi = () => new uploadApi.UploadApi(CONFIGURATION);
